import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';

@Component({
  selector: 'app-fee-due-alert-print',
  templateUrl: './fee-due-alert-print.component.html',
  styleUrls: ['./fee-due-alert-print.component.css']
})
export class FeeDueAlertPrintComponent implements OnInit {

  FeeReminderModel = {
    StudentID: 0,
    ClassID: 0,
    SectionID: 0,
    FromDate: ''
  }

  DisplayModel = {
    InstallmenDate: '',
    printdate: new Date(),
  }

  BranchDetails: any;
  InstallmentList: any = [];
  ReceiptList: any = [];
  FineRuleList: any = [];
  StudentReport: any = [];
  FeeOpenning: any = [];
  Integer: any;
  decimal: any;
  itemsPerPage = 10;
  pagedItems = [];

  constructor(private activatedRoute: ActivatedRoute, private finaService: FinanceService,
    private spinnerService: Ng4LoadingSpinnerService, public globalHelper: GlobalHelper) {
    this.activatedRoute.queryParams.subscribe(params => {
      var StudentID = params['StudentID'];
      var ClassID = params['ClassID'];
      var SectionID = params['SectionID'];
      var FromDate = params['FromDate'];
      this.StudentReport = [];
      var studentList = StudentID.split(',');
      for (var i = 0; i < studentList.length; i++) {
        this.FeeReminderModel = {
          ClassID: ClassID,
          SectionID: SectionID,
          StudentID: studentList[i],
          FromDate: FromDate,
        };
        this.GetFeeReminder();
      }
    });

  }

  GetFeeReminder() {
    this.spinnerService.show()
    this.finaService.GetFeeReminder(JSON.stringify(this.FeeReminderModel)).subscribe((response) => {
      this.BranchDetails = response.BranchDetails;
      this.spinnerService.hide()
      this.InstallmentList = response.InstallmentList;
      var InstallmenDate = '';
      if (this.InstallmentList != null && this.InstallmentList.length > 0) {
        for (var i = 0; i < this.InstallmentList.length; i++) {
          InstallmenDate = InstallmenDate + ',' + this.InstallmentList[i].AlertDate;
        }
        this.DisplayModel.InstallmenDate = InstallmenDate;
        this.FineRuleList = response.FineRuleList;
        var fe = response.FeeReminderList.length;
        var tp = response.TransportReminderList.length;
        if (fe > tp && tp != 0) {
          for (var i = 0; i < fe - tp; i++) {
            var itemTrans = {
              'AlertDate': '',
              'Amount': 0,
              'PaidAmount': 0,
              'DiscountAmount': 0,
            }
            response.TransportReminderList.push(itemTrans);
          }
        }
        else if (fe < tp) {
          for (i = 0; i < tp - fe; i++) {
            let itemTrans = {
              'AlertDate': '',
              'TotalAmount': 0,
              'PaidAmount': 0,
              'DiscountAmount': 0,
            }
            response.FeeReminderList.push(itemTrans);
          }
        }
        this.StudentReport.push(response);


        // this.search(this.GeneralPaymentList);
        this.spinnerService.hide()
        setTimeout(function () {
          window.print();
        }, 300);
      }
    });

  };

  GetTotalAmount(item) {
    var sum = 0;
    for (var i = 0; i < item.FeeReminderList.length; i++) {
      sum = sum + parseFloat(item.FeeReminderList[i].TotalAmount) - parseFloat(item.FeeReminderList[i].PaidAmount) - parseFloat(item.FeeReminderList[i].DiscountAmount);
    }

    return sum;

  }

  TGetTotalAmount(item) {
    var sum = 0;
    for (var i = 0; i < item.TransportReminderList.length; i++) {
      sum = sum + parseFloat(item.TransportReminderList[i].Amount) - parseFloat(item.TransportReminderList[i].PaidAmount) - parseFloat(item.TransportReminderList[i].DiscountAmount);
    }

    return sum;

  }

  GetDueAmount(item) {
    var CurrentDate = new Date();
    var year = CurrentDate.getFullYear();
    var month = CurrentDate.getMonth() + 1;
    var day = CurrentDate.getDate();

    var fine = 0;
    for (var i = 0; i < item.FeeReminderList.length; i++) {
      if (this.FineRuleList[0].IsPerDay) {
        var dayDiff = 0;
        dayDiff = this.dateDiff1(item.FeeReminderList[i].DueAlertDate, CurrentDate)
        if (dayDiff > this.FineRuleList[0].MaxFineDays) {
          dayDiff = this.FineRuleList[0].MaxFineDays;
        }

        if (fine == 0 && dayDiff > 0) {

          fine = dayDiff * this.FineRuleList[0].FineAmount;
          dayDiff = 0;
        }
        else if (dayDiff > 0) {
          fine = fine + dayDiff * this.FineRuleList[0].FineAmount;
          dayDiff = 0;
        }

      }
      else
        if (this.FineRuleList[0].IsFixed) {
          if (CurrentDate > new Date(item.FeeReminderList[i].DueAlertDate)) {

            if (fine == 0) {
              fine = this.FineRuleList[0].FineAmount;
            }
            else {
              fine = fine + this.FineRuleList[0].FineAmount;
            }
          }
        }
    }

    return (Math.round(fine * 1000) / 1000);


  }
  TGetDueAmount(item) {
    var CurrentDate = new Date();
    var year = CurrentDate.getFullYear();
    var month = CurrentDate.getMonth() + 1;
    var day = CurrentDate.getDate();

    var fine = 0;
    for (var i = 0; i < item.TransportReminderList.length; i++) {
      if (this.FineRuleList[0].IsPerDay) {
        var dayDiff = 0;
        dayDiff = this.dateDiff1(item.TransportReminderList[i].DueAlertDate, CurrentDate)
        if (dayDiff > this.FineRuleList[0].MaxFineDays) {
          dayDiff = this.FineRuleList[0].MaxFineDays;
        }

        if (fine == 0 && dayDiff > 0) {

          fine = dayDiff * this.FineRuleList[0].FineAmount;
          dayDiff = 0;
        }
        else if (dayDiff > 0) {
          fine = fine + dayDiff * this.FineRuleList[0].FineAmount;
          dayDiff = 0;
        }

      }
      else
        if (this.FineRuleList[0].IsFixed) {
          if (CurrentDate > new Date(item.TransportReminderList[i].DueAlertDate)) {

            if (fine == 0) {
              fine = this.FineRuleList[0].FineAmount;
            }
            else {
              fine = fine + this.FineRuleList[0].FineAmount;
            }
          }
        }

    }
    return (Math.round(fine * 1000) / 1000);


  }
  dateDiff1(firstDate, secondDate) {
    firstDate = new Date(firstDate);
    secondDate = new Date(secondDate);
    if (!isNaN(firstDate) && !isNaN(secondDate)) {
      firstDate.setHours(0, 0, 0, 0); //ignore time part
      secondDate.setHours(0, 0, 0, 0); //ignore time part
      var dayDiff = secondDate - firstDate;
      dayDiff = dayDiff / 86400000; // divide by milisec in one day
      return dayDiff;
    }
  }
  search(itemlist) {

    for (var i = 0; i < itemlist.length; i++) {
      if (i % this.itemsPerPage === 0) {
        this.pagedItems[Math.floor(i / this.itemsPerPage)] = [itemlist[i]];
      } else {
        this.pagedItems[Math.floor(i / this.itemsPerPage)].push(itemlist[i]);
      }
    }

  }

  ngOnInit() {
  }

}


